export default "__VITE_ASSET__229f8208__"